import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="faq-heading" data-id="element-53" data-mp="1l9o8reb6y9od">
      <div className="mx-auto max-w-3xl px-5" data-id="element-54" data-mp="1ge8rsdhvzxnq">
        <h2 id="faq-heading" className="text-center font-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-55" data-mp="2e066s0x25kux">
          Frequently asked questions
        </h2>

        <div className="mt-8 space-y-3" data-id="element-56" data-mp="24206fnqwgms6">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-3xl border border-blush-100 bg-cream" data-id="element-57" data-mp="1z2nkd57urjqn" data-mpi={index}>
                <h3 data-id="element-58" data-mp="nniextgc773c">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-base font-bold text-ink transition-colors hover:text-blush-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac-300 sm:text-lg" data-id="element-59" data-mp="nmyvg8b1gan7">
                    {faq.question}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-blush-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-60" data-mp="bi6i94vatv91" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-61" data-mp="3jxq5nn9agjg6">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} key="panel" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} data-id="element-62" data-mp="3nzbpjsk8pxzv">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-ink/75 sm:text-base" data-id="element-63" data-mp="1fryhq85p1eu6">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}